export default "__VITE_ASSET__DhfX3Fh3__"